<template>
    <div class="about">
        <BasicNavigation header-image="header_about.png"></BasicNavigation>
        <v-container grid-list-md text-xs-center>
            <v-layout row align-center justify-center wrap>
                <v-flex xs10 sm8 md3 lg3 xl3>
                    <v-card class="rounded-card">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">Laboratorium Satuan Pendidikan</h3>
                                <br>
                                <div>Kurikulum belajar yang rekreatif dan inovatif, terintegrasi dengan sistem pendidikan nasional dan menjadi pilihan utama untuk menyempurnakan pembelajaran teori di kelas.</div>
                            </div>
                        </v-card-title>
                        <v-img
                                src="/images/about_card1.png"
                                aspect-ratio="2.75"
                        ></v-img>
                    </v-card>
                </v-flex>
                <v-flex xs10 sm8 md3 lg3 xl3>
                    <v-card class="rounded-card">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">Deteksi Minat dan Bakat Anak</h3>
                                <br>
                                <div>Membantu orang tua menelusuri minat dan bakat anak melalui penilaian dan hasil observasi oleh tenaga profesional selama bermain dan kesempatan berkonsultasi di ruang psikologi.</div>
                            </div>
                        </v-card-title>
                        <v-img
                                src="/images/about_card2.png"
                                aspect-ratio="2.75"
                        ></v-img>
                    </v-card>
                </v-flex>
                <v-flex xs10 sm8 md3 lg3 xl3>
                    <v-card class="rounded-card">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">Pusat Hiburan Anak dan Orang Tua</h3>
                                <br>
                                <div>Konsep baru dalam kegiatan rekreasi keluarga dengan mengedepankan aspek edukasi.</div>
                                <br>
                                <br>
                            </div>
                        </v-card-title>
                        <v-img
                                src="/images/about_card3.png"
                                aspect-ratio="2.75"
                        ></v-img>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout row align-center justify-center wrap>
                <v-flex xs12 sm12 md5 lg5 xl5>
                    <v-img src="/images/cepi.png"></v-img>
                </v-flex>
                <v-flex xs12 sm12 md7 lg7 xl7>
                    <v-card>
                        <v-card-title primary-title>
                            <div style="text-align: left;">
                                <h3 class="headline mb-0">Bandung Champion City</h3>
                                <br>
                                <div>
                                    <p>Kota metropolitan mini untuk anak-anak yang dirancang sistematis dan realistis serupaa dengan tatanan dan struktur kota sebenarnya. Memiliki kurikulum yang terintegrasi dengan program pendidikan nasional "Belajar di Luar Kelas" sebagai laboratorium satuan pendidikan.</p>
                                    <p>Terdiri darim 78 wahana dan 177 profesi dalam area seluas 10.000 m2 yang terpantau ketat pleh kamera CCTV  yang terhuubung langsung dengan orang tua atau pendamping melalui ponsel pintar.</p>
                                </div>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout row align-center justify-center>
                <h1>Partnership</h1>
                <br>
            </v-layout>
            <v-layout row align-center justify-center>
                <v-carousel hide-delimiters style="height: 480px;">
                    <v-carousel-item
                            v-for="(item,i) in itemSliderPartnership"
                            :key="item.id"
                            reverse-transition="fade"
                            transition="fade"
                    >
                        <img :src="item.image_file" style="width:100%;"/>
                    </v-carousel-item>
                </v-carousel>
            </v-layout>
            <v-layout row align-center justify-center wrap mt-4>
                <v-flex xs12 sm12 md3>
                    <div class="info_title">177</div>
                    <div>Profesi</div>
                </v-flex>
                <v-flex xs12 sm12 md3>
                    <div class="info_title">78</div>
                    <div>Wahana</div>
                </v-flex>
                <v-flex xs12 sm12 md3>
                    <div class="info_title">10.000 M2</div>
                    <div>Luas Area</div>
                </v-flex>
                <v-flex xs12 sm12 md3>
                    <div class="info_title">2500+</div>
                    <div>Pengunjung</div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<style scoped>
    .rounded-card{
        border-radius:10px;
    }
    .info_title {
        font-size: 20pt;
        color: #434242;
        font-weight: bolder;
    }
</style>

<script>
    import HomeAPI from "@/api/home";
    import BasicNavigation from "@/components/BasicNavigation";

    export default {
        layout: 'basic',
        components: {
            BasicNavigation
        },
        data() {
            return {
                itemSliderPartnership: []
            }
        },
        name: 'about',
        mounted: function(){
            HomeAPI.getPartnership().then(response => {
                this.itemSliderPartnership = response.data.results.data;
            });
        }
    }
</script>